<template>
    <ResultsGridLayout class="single-line-grid-layout">
        <ProfileCard
            v-for="(profile, index) in fakeProfiles"
            :id="`fake-profile-card-${index}`"
            :key="index"
            :loading="skeleton"
            :profile="profile"
        />
    </ResultsGridLayout>
</template>

<script setup lang="ts">
    import type {Profile} from '@profile-card/components/profile-card/types';
    import {ProfileCard} from '#components';
    import ResultsGridLayout from '../../layouts/ResultsGridLayout.vue';

    withDefaults(
        defineProps<{
            skeleton?: boolean;
        }>(),
        {
            skeleton: false,
        },
    );

    const fakeProfiles = [
        generateProfile('baptiste_duhen_1', 'Baptiste', 'Duhen', 600),
        generateProfile('Agata_FRYDRYCH_1', 'Agatha', 'Frydrych', 800),
        generateProfile('Admin_Amed_Atchamou_1', 'Amed', 'Hamou', 700),
        generateProfile('Admin_Cecile_Pelletier_2', 'Audrey', 'Champion', 600),
        generateProfile('charles_d%27oiron_1', 'Charles', 'd’Oiron', 800),
        generateProfile('christina-wocintechchat', 'Christina', 'Wocinte', 700),
    ];

    function generateProfile(id: string, firstName: string, lastName: string, price: number): Profile {
        return {
            firstName,
            lastNameNormalized: lastName,
            location: {
                city: 'Paris',
                locationType: 'EXACT',
            },
            headline: 'Consultant stratégie IT secteur public',
            photoUrl: `https://dam.malt.com/hopsearch/banner--malt-exec/${id}.jpg`,
            price: {
                visibility: 'VISIBLE',
                formattedValue: `${price} €`,
            },
            availability: {
                status: 'AVAILABLE',
                workAvailability: 'FULL_TIME',
                nextAvailabilityDate: undefined,
                frequency: 'FULL_TIME',
            },
            stats: {
                rating: 5,
                appraisalsWithRatesCount: 10,
                invalidatedCharter: false,
                recommendationsCount: 3,
            },
            badges: [],
            skills: ['IT', 'Strategy', 'Public sector', 'Project management'],
            portfolio: [],
        };
    }
</script>

<style scoped lang="scss">
    .single-line-grid-layout {
        // additional lines automatically generated should have a 0px height
        grid-auto-rows: 0;
        // hide cell content overflowing so cells with 0px heigh are not visible
        overflow-y: hidden;
        // remove row gap to avoid a bottom margin
        row-gap: 0;
    }
</style>
